import * as R from 'ramda';
import * as actionTypes from '../actionTypes';

const state = {
  isLoadingGetIndexPageEdit: false,
  getIndexPageEditMessage: '',
  getIndexPageEditFailed: '',

  isLoadingPostIndexPage: false,
  postIndexPageMessage: '',
  postIndexPageFailed: '',

  isLoadingPatchIndexPageEdit: false,
  patchIndexPageEditMessage: '',
  patchIndexPageEditFailed: '',

  isLoadingGetGuestIndexPage: false,
  getGuestIndexPageMessage: '',
  getGuestIndexPageFailed: '',

  isLoadingGetIndexPagePreview: false,
  getIndexPagePreviewMessage: '',
  getIndexPagePreviewFailed: '',
};

const initialState = R.clone(state);

function indexPageReducer(globalState = state, action) {
  switch (action.type) {
    case actionTypes.INITIALIZE_STATES_FULFILLED:
      return {
        ...initialState,
      };
    case actionTypes.GET_INDEX_PAGE_EDIT_PENDING:
      return {
        ...globalState,
        isLoadingGetIndexPageEdit: true,
      };
    case actionTypes.GET_INDEX_PAGE_EDIT_FULFILLED:
      return {
        ...globalState,
        isLoadingGetIndexPageEdit: false,
        getIndexPageEditMessage: action.data,
        getIndexPageEditFailed: '',
      };
    case actionTypes.GET_INDEX_PAGE_EDIT_FAILURE:
      return {
        ...globalState,
        isLoadingGetIndexPageEdit: false,
        getIndexPageEditMessage: '',
        getIndexPageEditFailed: action.error,
      };
    case actionTypes.PATCH_INDEX_PAGE_EDIT_PENDING:
      return {
        ...globalState,
        isLoadingPatchIndexPageEdit: true,
      };
    case actionTypes.PATCH_INDEX_PAGE_EDIT_FULFILLED:
      return {
        ...globalState,
        isLoadingPatchIndexPageEdit: false,
        patchIndexPageEditMessage: action.data,
        patchIndexPageEditFailed: '',
      };
    case actionTypes.PATCH_INDEX_PAGE_EDIT_FAILURE:
      return {
        ...globalState,
        isLoadingPatchIndexPageEdit: false,
        patchIndexPageEditMessage: '',
        patchIndexPageEditFailed: action.error,
      };
    case actionTypes.GET_GUEST_INDEX_PAGE_PENDING:
      return {
        ...globalState,
        isLoadingGetGuestIndexPage: true,
      };
    case actionTypes.GET_GUEST_INDEX_PAGE_FULFILLED:
      return {
        ...globalState,
        isLoadingGetGuestIndexPage: false,
        getGuestIndexPageMessage: action.data,
        getGuestIndexPageFailed: '',
      };
    case actionTypes.GET_GUEST_INDEX_PAGE_FAILURE:
      return {
        ...globalState,
        isLoadingGetGuestIndexPage: false,
        getGuestIndexPageMessage: '',
        getGuestIndexPageFailed: action.error,
      };
    case actionTypes.POST_INDEX_PAGE_PENDING:
      return {
        ...globalState,
        isLoadingPostIndexPage: true,
      };
    case actionTypes.POST_INDEX_PAGE_FULFILLED:
      return {
        ...globalState,
        isLoadingPostIndexPage: false,
        postIndexPageMessage: action.data,
        postIndexPageFailed: '',
      };
    case actionTypes.POST_INDEX_PAGE_FAILURE:
      return {
        ...globalState,
        isLoadingPostIndexPage: false,
        postIndexPageMessage: '',
        postIndexPageFailed: action.error,
      };
    case actionTypes.GET_INDEX_PAGE_PREVIEW_PENDING:
      return {
        ...globalState,
        isLoadingGetIndexPagePreview: true,
      };
    case actionTypes.GET_INDEX_PAGE_PREVIEW_FULFILLED:
      return {
        ...globalState,
        isLoadingGetIndexPagePreview: false,
        getIndexPagePreviewMessage: action.data,
        getIndexPagePreviewFailed: '',
      };
    case actionTypes.GET_INDEX_PAGE_PREVIEW_FAILURE:
      return {
        ...globalState,
        isLoadingGetIndexPagePreview: false,
        getIndexPagePreviewMessage: '',
        getIndexPagePreviewFailed: action.error,
      };
    default:
      return globalState;
  }
}

export default indexPageReducer;
